import React, { useRef, useState } from 'react'
import classNames from 'classnames'
import Webcam from 'react-webcam'

import CameraFrameSVG from '../../../assets/icons/camera_frame.svg'
import FlipCameraIcon from '../../../assets/icons/flip_cemera_icon.svg'

const CameraComponent = ({
  setImage,
  cameraScreenClass = '',
  showCamera = false,
}) => {
  const webcamRef = useRef(null)
  const [facingMode, setFacingMode] = useState('environment')
  const capture = () => {
    const imageSrc = webcamRef.current?.getScreenshot()
    setImage(imageSrc || null)
  }

  const flipCamera = () => {
    setFacingMode((prev) => (prev === 'user' ? 'environment' : 'user'))
  }
  const videoConstraints = {
    width: 500, // Ensure a square resolution
    height: 500,
    facingMode: facingMode,
  }

  return (
    <div>
      <div
        className={classNames(
          'h-[calc(100dvh-281px)]  bg-black relative flex items-center justify-center',
          cameraScreenClass,
        )}
      >
        <img src={CameraFrameSVG} className="absolute " />
        {showCamera ? (
          <Webcam
            audio={false}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            screenshotQuality={1}
            videoConstraints={videoConstraints}
            style={{ width: '100%', height: 'auto', maxHeight: '450px' }}
          />
        ) : (
          <></>
        )}
      </div>
      <div className="bg-black p-4 w-full flex items-center justify-center relative">
        {/* capture button */}
        <div
          className="p-1 h-[70px] w-[70px]  rounded-full border-2 border-white bg-black"
          onClick={() => {
            capture()
          }}
        >
          <div className=" rounded-full bg-white w-full h-full"></div>
        </div>
        {/* flip icon */}
        <div className="absolute right-[10%]">
          <img src={FlipCameraIcon} className="h-7 w-7" onClick={flipCamera} />
        </div>
      </div>
    </div>
  )
}

export default CameraComponent
